import { deleteAsync, getInfoAsync } from 'expo-file-system/legacy';
import api from '@/api/axios';
import { getAccessToken } from '@/stores/auth/services';
import encryptedStorage from '@/stores/encryptedStorage';
import store from '@/stores/store';
import { ASSETS_DIR } from '@/contexts/DownloadAssetContext/createAssetDownloaderInstance';
import { IS_WEB } from '@/utils/platform';
import { resetPostHog } from '@/contexts/EventsProvider/posthogClient';
import { logError } from '@/utils/logHandling';

let _isLoggingOut = false;
export const isLoggingOut = () => _isLoggingOut;

export const localLogoutUser = async (accountWasDeleted = false) => {
  const { lastLoginEmail, isTherapistDemo } = store.getState();

  if (store.getState().isAuthenticated) {
    if (!IS_WEB) {
      const dirInfo = await getInfoAsync(ASSETS_DIR);
      if (dirInfo.exists) {
        await deleteAsync(ASSETS_DIR, { idempotent: true });
      }
    }

    if (store.getState().therapistWebAppLogin) {
      store.getActions().setTherapistWebAppLogin(false);
      window.location.href = window.location.href.split('?')[0];
    }
    resetPostHog();

    await store.getActions().reset();
    await store.getActions().setIsAuthenticated(false);

    if (accountWasDeleted) {
      await encryptedStorage().setItem('accountWasDeleted', 'true');
    }

    if (!isTherapistDemo) {
      await store.getActions().setLastLoginEmail(lastLoginEmail);
    }
  }
};

export const serverLogoutUser = (payload: { jwt: string }) => {
  if (payload.jwt && payload.jwt.length > 2) {
    return api.post('/api/auth/signout/v2', payload);
  } else {
    return null;
  }
};

export function useAuth() {
  async function logout() {
    _isLoggingOut = true;
    try {
      await serverLogoutUser({ jwt: (await getAccessToken()) ?? '' });
      await localLogoutUser();
    } catch {
      await localLogoutUser();
    } finally {
      _isLoggingOut = false;
    }
  }

  async function logoutAndClearAll() {
    _isLoggingOut = true;
    try {
      await serverLogoutUser({ jwt: (await getAccessToken()) ?? '' });
    } catch (e) {
      logError('Server logout failed', e);
    } finally {
      if (!IS_WEB) {
        const dirInfo = await getInfoAsync(ASSETS_DIR);
        if (dirInfo.exists) {
          await deleteAsync(ASSETS_DIR, { idempotent: true });
        }
      }
      // the order below matters and ensures localforage keys are deleted
      await encryptedStorage().clearAll();
      await store.getActions().setStayLoggedIn(false);
      await store.getActions().setLastLoginEmail('');
      await store.getActions().setIsAuthenticated(false);
      await store.getActions().reset();
      await store.persist.clear();
      _isLoggingOut = false;
    }
  }

  return { logout, logoutAndClearAll };
}
